<template>
  <div class="train__info" v-if="active">
    <div class="train__item" uk-tooltip="Ошибок сделано" v-if="hasErrors">
      <div class="train__ico train__ico--2"></div>
      <small>Ошибок:</small>
      {{ errors }}
    </div>
    <div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
      <div class="train__ico train__ico--4"></div>
      <small>Выполнено:</small>
      <div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
    </div>
    <div class="train__item" uk-tooltip="Времени прошло" v-if="hasTimer">
      <div class="train__ico train__ico--3"></div>
      <div>
        <small>Времени прошло:</small>
        <!--<br class="uk-visible@s">-->
        {{ timer.minutes }} мин. {{ timer.seconds }} сек.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "infoblock",
  data() {
    return {
      timer_id: '',
      timer: {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        total_ms: 0
      },
    }
  },
  watch: {
    active: 'checkStart'
  },
  props: {
    hasTimer: {
      default: true
    },
    hasErrors: {
      default: false
    },
    errors: '',
    active: ''
  },
  methods: {
    startTimer() {
      let duration = moment.duration({
        'seconds': 0,
      });
      this.timer_id = setInterval(() => {
        duration = moment.duration(duration.asSeconds() + 1, 'seconds');
        this.timer = duration._data;
        this.timer.total_ms = duration._milliseconds;
      }, 1000);
    },


    stopTimer() {
      if (this.timer_id) clearInterval(this.timer_id);
      this.timer = {
        total: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        total_ms: 0
      }
    },

    checkStart() {
      if (this.hasTimer && this.active) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
    },
  },
  mounted() {
    this.checkStart();
  },
  beforeDestroy() {
    this.stopTimer();
  }
}
</script>
